import styled from 'styled-components';
import { ModalFooter } from 'syf-component-library/ui/patterns/SlideInModal';
export const AsyncModalFooter = styled(ModalFooter) `
  button[data-loading='true'] {
    background-color: #34657e;
  }
`;
